import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    options: {
        customProperties: true
    },
    theme: {
        themes: {
            light: {
                primary: '#4575A1',
                secondary: '#fafafa',
                accent: '#66ABCF',
                tertiary: '#57AEA6',
                error: '#D84B44',
                text: '#000000',
                background: '#FFFFFF'
            },
            dark: {
                primary: '#4575A1',
                secondary: '#222222',
                accent: '#66ABCF',
                tertiary: '#57AEA6',
                error: '#D84B44',
                text: '#FFFFFF',
                background: '#121212'
            }
        }
    }
});
